// Light / dark theme switch. The choice is stored in a cookie so the server
// can render the right theme class on <html> (no flash on load). Without a
// choice the system preference applies (see build/postcss_dark_class.js).

function isDark() {
  const classes = document.documentElement.classList;
  if (classes.contains('dark')) {
    return true;
  }
  if (classes.contains('light')) {
    return false;
  }
  return (
    !!window.matchMedia &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
  );
}

function toggleTheme() {
  const dark = !isDark();
  const classes = document.documentElement.classList;
  classes.toggle('dark', dark);
  classes.toggle('light', !dark);
  document.cookie = `theme=${
    dark ? 'dark' : 'light'
  }; path=/; max-age=31536000; samesite=lax`;
  return dark;
}

module.exports = { isDark, toggleTheme };
